



















import { Component, Vue } from "vue-property-decorator";
import { templateApi } from "../api";
import {
  saveProject,
  saveEndUserProject,
  getDefaultIcon,
  ProjectTaskDefault
} from "@/api/project-api";
import { getAllClients, getAllClientStaffs, Client } from "@/api/client-api";
import { Staff } from "@/api/company-api";
import { Company, Office } from "@/api/company-api";
import ProjectFormData from "@/api/models/ProjectFormData";
import ProjectFormEndUserData from "@/api/models/ProjectFormEndUserData";
import createProjectOutput from "@/api/models/factories/createProjectOutput";
import createOrderOutput from "@/api/models/factories/createOrderOutput";

import AppHeader from "@/views/AppHeader.vue";
import ProjectEdit from "@/templates/ProjectEdit.vue";
import ProjectTemplate from "../models/project-template";
import UploadFileSpec from "../models/specs/UploadFileSpec";
import SelectOption from "@/common/ui/presenters/select-option";
import createCompany from "@/helpers/createCompany";
import { getProjectPropertyKeys } from "@/api/project/project-properties-api";
import { ProjectProperty } from "@/api/project-api";
import { getServiceTaskDefaults } from "@/api/project/service-task-default-api";
import { ServiceTaskDefault } from "@/api/project/service-task-default-api";
import emitter from "@/EventBus";

@Component({
  components: {
    AppHeader,
    ProjectEdit
  }
})
export default class ProjectNewPage extends Vue {
  project = createProjectOutput();
  order = createOrderOutput();
  company: Company | null = null;
  office: Office | null = null;

  get clientOptions(): SelectOption[] {
    return this.clientList.map(c => new SelectOption(c, "id", "name"));
  }

  get clientStaffOptions(): SelectOption[] {
    return this.filteredClientStaffList
      .filter(s => s.isHiddenInfo === 0)
      .map(s => new SelectOption(s, "staffId", "name"));
  }

  get templateOptions(): SelectOption[] {
    return this.templateList.map(t => new SelectOption(t, "id", "title"));
  }

  async ok() {
    try {
      await this.save();
      this.goListPage();
    } catch (e) {
      alert("エラーのため送信できませんでした。");
      emitter.emit("message", e);
    }
  }

  cancel() {
    this.goListPage();
  }

  updateIcon(e: Event) {
    const files = (e.target as HTMLInputElement).files;
    if (!files || !files[0]) return;
    const spec = new UploadFileSpec();
    if (!spec.isSatisfied(files[0])) {
      alert(spec.errors);
      return;
    }
    const url = URL.createObjectURL(files[0]);
    this.project.icon = url;
    this.project.iconFile = files[0];
  }

  private clientList: Client[] = [];
  private clientStaffList: Staff[] = [];
  private templateList: ProjectTemplate[] = [];

  private get filteredClientStaffList(): Staff[] {
    const cid = this.order.clientId;
    if (!cid) return this.clientStaffList;
    return this.clientStaffList.filter(
      s => cid === String(s.officeId) && s.isHiddenInfo === 0
    );
  }

  public created() {
    [this.company, this.office] = createCompany();
    this.initIcon();
    this.initClientList();
    this.initClientStaffList();
    this.initTemplateList();
    this.getProjectPropertyKeys();
    this.getServiceTaskDefaults();
  }

  private async initIcon() {
    this.project.icon = await getDefaultIcon();
  }

  private async initClientList() {
    this.clientList = await getAllClients();
  }

  private async initClientStaffList() {
    this.clientStaffList = await getAllClientStaffs();
  }

  private async initTemplateList() {
    this.templateList = await templateApi.getAll();
  }

  private async save() {
    if (!this.company || !this.office) return;
    if (!this.order.endUser) {
      const d = ProjectFormData(this.project, this.order);
      await saveProject(d);
      await this.$store.dispatch("updateProjects");
    } else {
      const d = ProjectFormEndUserData(
        this.project,
        this.order,
        this.company,
        this.office
      );
      await saveEndUserProject(d);
      await this.$store.dispatch("updateProjects");
    }
    await this.$store.dispatch("getUnreadMessage");
  }

  private goListPage() {
    this.$router.push({ name: "project-list" });
  }

  private async getProjectPropertyKeys() {
    const projectPropertyKeys = await getProjectPropertyKeys();
    const data: ProjectProperty[] = projectPropertyKeys
      .filter(projectPropertyKey => !projectPropertyKey.deletedAt)
      .map(projectPropertyKey => {
        return {
          key: {
            id: projectPropertyKey.id,
            name: projectPropertyKey.name,
            project_no_method: projectPropertyKey.project_no_method,
            deletedAt: projectPropertyKey.deletedAt
          },
          value: ""
        };
      });

    this.project.additionalProperties = data;
  }

  private async getServiceTaskDefaults() {
    const serviceTaskDefaults = await getServiceTaskDefaults();
    serviceTaskDefaults.forEach((item: ServiceTaskDefault) => {
      if (item.code == "Project task default") {
        this.project.taskDefaults.push({
          key: {
            id: item.id,
            name: item.name
          },
          value: item.value
        } as ProjectTaskDefault);
      }
    });
  }
}
